import { downloadFile, getFileUrl } from '@/shared/utilities';
import { useMutation } from '@tanstack/react-query';

export const useDownload = (path: string, fileName: string) => {
  return useMutation({
    mutationFn: async () => {
      const url = await getFileUrl(path);
      downloadFile(url, fileName || 'download');
    }
  });
};
